// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#portal-body{margin-left:50px}.su-icon-erweima:before,.su-icon-taocanguanli:before{color:#000;font-size:14px}", ""]);
// Exports
module.exports = exports;
